<template>
  <div class="row justify-content-between">
    <div
      v-for="(item, index) in viewFields"
      :key="index"
      :class="item.class"
      class="mt-2"
    >
      <div v-if="item.type == 'image'">
        <label class="viewLabel">{{ item.label }}</label>
        <b-media-aside>
          <b-link>
            <b-img
              ref="previewEl"
              rounded
              :src="
                data[item.field] && data[item.field] !== null
                  ? data[item.field].includes(imagePath)
                    ? data[item.field]
                    : imagePath + data[item.field]
                  : 'https://aircraft.wpenginepowered.com/wp-content/uploads/2016/09/no-profile-img.jpg'
              "
              height="80"
            />
          </b-link>
        </b-media-aside>
      </div>
      <div v-else-if="item.type == 'text'">
        <label class="viewLabel">{{ item.label }} :</label>
        <p class="viewValue">
          <template v-if="(item.field == 'leadsource' || item.field == 'subsource') && data[item.field]">
            <template v-if="typeof data[item.field] === 'string'">
              {{ getJsonFieldName(data[item.field]) || "NA" }}
            </template>
            <template v-else-if="Array.isArray(data[item.field]) && data[item.field].length > 0">
              {{ data[item.field][0].name || data[item.field][0] || "NA" }}
            </template>
            <template v-else-if="typeof data[item.field] === 'object' && data[item.field] !== null">
              {{ data[item.field].name || data[item.field] || "NA" }}
            </template>
            <template v-else>
              {{ data[item.field] || "NA" }}
            </template>
          </template>
          <template v-else-if="(item.field == 'leadsource' || item.field == 'subsource') && !data[item.field]">
            NA
          </template>
          <template v-else>
            {{ data[item.field] || resolvedValues[item.field] || "NA" }}
          </template>
        </p>
      </div>
      <div v-else-if="item.type == 'date'">
        <label class="viewLabel">{{ item.label }} :</label>
        <p class="viewValue">
          {{ data[item.field] ? formatDate(data[item.field]) : "-" }}
        </p>
      </div>
      <div v-else-if="item.type == 'datetime'">
        <label class="viewLabel">{{ item.label }} :</label>
        <p class="viewValue">
          {{
            data[item.field] ? formatDateTime(data[item.field]) : "-"
          }}
        </p>
      </div>
      <div v-else-if="item.type == 'fieldInObj'">
        <label class="viewLabel">{{ item.label }} :</label>
        <p
          class="viewValue"
          v-if="(data[item.field] || (item.fallbackField && data[item.fallbackField])) && item.childFieldType == 'text'"
        >
          <!-- Check primary field first -->
          <template v-if="data[item.field]">
            <template v-if="typeof data[item.field] === 'string'">
              {{ data[item.field] || "NA" }}
            </template>
            <template v-else-if="typeof data[item.field] === 'object' && data[item.field] !== null">
              {{ data[item.field][item.childField] || data[item.field].name || data[item.field] || "NA" }}
            </template>
            <template v-else>
              {{ data[item.field] || "NA" }}
            </template>
          </template>
          <!-- Check fallback field if primary doesn't exist -->
          <template v-else-if="item.fallbackField && data[item.fallbackField]">
            <template v-if="typeof data[item.fallbackField] === 'string'">
              {{ data[item.fallbackField] || "NA" }}
            </template>
            <template v-else-if="typeof data[item.fallbackField] === 'object' && data[item.fallbackField] !== null">
              {{ data[item.fallbackField][item.childField] || data[item.fallbackField].name || data[item.fallbackField] || "NA" }}
            </template>
            <template v-else>
              {{ data[item.fallbackField] || "NA" }}
            </template>
          </template>
          <template v-else>
            NA
          </template>
        </p>
        <p class="viewValue" v-else-if="!data[item.field] && (!item.fallbackField || !data[item.fallbackField])">
          NA
        </p>
        <attachment
          :data="data[item.field] && data[item.field][item.childField]"
          v-else-if="item.childFieldType == 'attachment' && data[item.field]"
        />
      </div>
      <div v-else-if="item.type == 'email'">
        <label class="viewLabel">{{ item.label }} :</label>
        <p class="viewValue">{{ data[item.field] }}</p>
      </div>
      <div v-else-if="item.field == 'anniversarydate' && data.maritalstatus == 'Married'">
        <label class="viewLabel">{{ item.label }} :</label>
        <p class="viewValue">{{ data[item.field] }}</p>
      </div>
      <div v-else-if="item.type == 'heading'" class="mb-1 mt-3">
        <span style="font-weight: 500; font-size: 1.285rem">{{ item.label }}</span>
      </div>

      <div
        v-else-if="item.type == 'dropdown'"
      >
        <label class="viewLabel">{{ item.label }} :</label>
        <p class="viewValue" v-if="data[item.field] && Array.isArray(data[item.field])">
          <span v-for="(option, optionIndex) in data[item.field]" :key="optionIndex">
            {{ getDropdownValue(option, item) || "NA" }}
            <span v-if="optionIndex !== data[item.field].length - 1">
              {{ typeof item.separator !== 'undefined' ? item.separator : ', ' }}
            </span>
          </span>
        </p>
        <p class="viewValue" v-else-if="data[item.field]">
          {{ getDropdownValue(data[item.field], item) || "NA" }}
        </p>
        <p class="viewValue" v-else>
          NA
        </p>
      </div>
      <div v-else-if="item.type == 'attachment'">
        <label class="viewLabel">{{ item.label }} :</label>
        <p><attachment :data="data[item.field]" /></p>
      </div>
      <div
        v-else-if="
          item.type == 'leadaccess' && data.position && data.position.name == 'leadmanage'
        "
      >
        <label class="viewLabel">{{ item.label }} :</label>
        <p class="viewValue">{{ data[item.field] }}</p>
      </div>
      <div v-else-if="item.type == 'multiple'">
        <div style="width: 100%; max-height: 500px; overflow: auto">
          <table class="table table-bordered" style="min-width: 15cm">
            <thead class="text">
              <tr>
                <th>Sr. No</th>
                <th v-for="(th, thIndex) in item.tableHead" :key="thIndex">{{ th }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(td, id) in typeof data[item.field] == 'string'
                  ? JSON.parse(data[item.field])
                  : data[item.field]"
                :key="id"
              >
                <td>{{ id + 1 }}</td>
                <td v-for="(multi, multiIn) in item.tableField" :key="multiIn">
                  <div v-if="multi.type == 'text'">
                    {{ multi.responseValue && td[multi.field] && typeof td[multi.field] == 'object' 
                      ? td[multi.field][multi.responseValue] 
                      : td[multi.field] }}
                  </div>
                  <div v-if="multi.type == 'attachment'">
                    <attachment :data="td[multi.field]" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <slot name="extraView" :data="data" :item="item"></slot>
    </div>
  </div>
</template>
<script>
import {
  BFormCheckbox,
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BInputGroupAppend,
  BCol,
  BInputGroup,
  BFormFile,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BImg,
} from "bootstrap-vue";
import axios from "@/components/axios";
import moment from "moment";
import Attachment from "@/components/Attechment.vue";
export default {
  components: {
    BFormCheckbox,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormGroup,
    BFormFile,
    Attachment,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormDatepicker,
    BFormTextarea,
    BImgLazy,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BImg,
  },
  props: {
    viewFields: {
      default: [],
    },
    title: {
      default: "",
    },
    moduleapi: {
      default: "",
    },
    closepopup: {
      default: () => {},
    },
    getEditValue: {
      default: "",
    },
    selectedID: {
      default: 0,
    },
  },
  data() {
    return {
      imagePath: process.env.VUE_APP_IMAGE_PATH,
      moment,
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      data: [],
      loginData: JSON.parse(localStorage.getItem("userData")),
      resolvedValues: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatRoleName(role) {
      if (!role) return "NA";
      const roleMap = {
        'companyassociatepartner': 'Company Associate Partner',
        'employee': 'Employee',
        'franchise': 'Franchise',
        'admin': 'Admin',
        'self': 'Self'
      };
      return roleMap[role.toLowerCase()] || role.charAt(0).toUpperCase() + role.slice(1);
    },
    getJsonFieldName(jsonString, fieldName = 'name') {
      try {
        const parsed = typeof jsonString === 'string' ? JSON.parse(jsonString) : jsonString;
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed[0][fieldName] || parsed[0].name || parsed[0];
        } else if (typeof parsed === 'object' && parsed !== null) {
          return parsed[fieldName] || parsed.name || JSON.stringify(parsed);
        }
        return jsonString;
      } catch (e) {
        return jsonString;
      }
    },
    getDropdownValue(option, item) {
      if (option === null || option === undefined) {
        return "";
      }

      const responseValue = item?.responseValue;

      const resolveValue = (source, key) => {
        if (!source || key === undefined || key === null) {
          return undefined;
        }

        if (Array.isArray(key)) {
          for (const singleKey of key) {
            const value = resolveValue(source, singleKey);
            if (value !== undefined && value !== null) {
              return value;
            }
          }
          return undefined;
        }

        if (typeof key === "string") {
          if (source[key] !== undefined && source[key] !== null) {
            return source[key];
          }

          if (key.includes(".")) {
            return key.split(".").reduce((acc, part) => {
              if (acc === undefined || acc === null) {
                return undefined;
              }
              return acc[part];
            }, source);
          }
        }

        return undefined;
      };

      let value = resolveValue(option, responseValue);

      if (value === undefined && typeof option === "object" && !Array.isArray(option)) {
        const nestedCandidates = ["branch", "branch_data", "location", "details", "meta", "pivot"];
        for (const candidate of nestedCandidates) {
          value = resolveValue(option[candidate], responseValue);
          if (value !== undefined && value !== null) {
            break;
          }
        }
      }

      if (value === undefined || value === null) {
        if (typeof option === "object" && !Array.isArray(option)) {
          const fallbackKeys = [
            responseValue,
            "name",
            "title",
            "label",
            "value",
            "fullname",
            "full_name",
          ].filter(Boolean);

          for (const key of fallbackKeys) {
            value = resolveValue(option, key);
            if (value !== undefined && value !== null) {
              break;
            }
          }

          if (value === undefined || value === null) {
            value = option.toString?.() ?? "";
          }
        } else {
          value = option;
        }
      }

      return value ?? "";
    },
    formatDate(dateValue) {
      if (!dateValue) return "-";
      
      // If already a valid date string in DD/MM/YYYY format, return as is
      if (typeof dateValue === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateValue)) {
        return dateValue;
      }
      
      // Try parsing with DD/MM/YYYY format first
      let date = moment(dateValue, "DD/MM/YYYY", true);
      if (date.isValid()) {
        return date.format("DD/MM/YYYY");
      }
      
      // Try parsing with YYYY-MM-DD format (ISO)
      date = moment(dateValue, "YYYY-MM-DD", true);
      if (date.isValid()) {
        return date.format("DD/MM/YYYY");
      }
      
      // Try parsing with YYYY-MM-DD HH:mm:ss format (datetime)
      date = moment(dateValue, "YYYY-MM-DD HH:mm:ss", true);
      if (date.isValid()) {
        return date.format("DD/MM/YYYY");
      }
      
      // Try default moment parsing
      date = moment(dateValue);
      if (date.isValid()) {
        return date.format("DD/MM/YYYY");
      }
      
      // If all parsing fails, return the original value or "-"
      return dateValue || "-";
    },
    formatDateTime(dateValue) {
      if (!dateValue) return "-";
      
      // If already a valid date string in DD/MM/YYYY format, add default time
      if (typeof dateValue === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateValue)) {
        const date = moment(dateValue, "DD/MM/YYYY", true);
        return date.isValid() ? date.format("DD/MM/YYYY h:m A") : dateValue;
      }
      
      // Try parsing with DD/MM/YYYY format first
      let date = moment(dateValue, "DD/MM/YYYY", true);
      if (date.isValid()) {
        return date.format("DD/MM/YYYY h:m A");
      }
      
      // Try parsing with YYYY-MM-DD format (ISO)
      date = moment(dateValue, "YYYY-MM-DD", true);
      if (date.isValid()) {
        return date.format("DD/MM/YYYY h:m A");
      }
      
      // Try parsing with YYYY-MM-DD HH:mm:ss format (datetime)
      date = moment(dateValue, "YYYY-MM-DD HH:mm:ss", true);
      if (date.isValid()) {
        return date.format("DD/MM/YYYY h:m A");
      }
      
      // Try default moment parsing
      date = moment(dateValue);
      if (date.isValid()) {
        return date.format("DD/MM/YYYY h:m A");
      }
      
      // If all parsing fails, return the original value or "-"
      return dateValue || "-";
    },
    async getData() {
      await axios({
        method: "GET",
        url: `${this.getEditValue}/${this.selectedID}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          this.data = Array.isArray(json.data.data) ? json.data.data[0] : json.data.data;
          // If vendortypaname doesn't exist but vendortype (ID) does, resolve it
          if (!this.data.vendortypaname && this.data.vendortype && typeof this.data.vendortype === 'number') {
            this.resolveVendorTypeName(this.data.vendortype);
          }
          // Resolve parent ID to name if parent is a number and not an object
          if (this.data.parent && typeof this.data.parent === 'number') {
            this.resolveParentName(this.data.parent);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    async resolveVendorTypeName(vendorTypeId) {
      try {
        const response = await axios({
          method: "GET",
          url: `${this.baseApi}/getvendortype`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
        });
        const options = response.data.data?.data || response.data.data || response.data;
        const found = Array.isArray(options) 
          ? options.find(opt => opt.id === vendorTypeId)
          : null;
        if (found) {
          this.resolvedValues.vendortypaname = found.vendortype || found.name || found;
          // Update the data object so it displays
          this.$set(this.data, 'vendortypaname', this.resolvedValues.vendortypaname);
        }
      } catch (error) {
        console.log(error, "error resolving vendor type name");
      }
    },
    async resolveParentName(parentId) {
      try {
        // Check if we need to resolve parent - look for viewFields with parent field and URL
        const parentField = this.viewFields?.find(field => field.field === 'parent' && field.url);
        if (!parentField || !parentField.url) {
          return;
        }
        
        const response = await axios({
          method: "GET",
          url: `${this.baseApi}/${parentField.url}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
        });
        const options = response.data.data?.data || response.data.data || response.data;
        const found = Array.isArray(options) 
          ? options.find(opt => opt.id === parentId)
          : null;
        if (found) {
          const parentName = found[parentField.responseValue] || found.name || found;
          this.resolvedValues.parent = parentName;
          // Update the data object so it displays - convert ID to object for dropdown type
          this.$set(this.data, 'parent', found);
        }
      } catch (error) {
        console.log(error, "error resolving parent name");
      }
    },
  },
};
</script>
<style scoped>
.viewLabel {
  font-size: 15px !important;
  font-weight: 500 !important;
}
.viewValue {
  font-size: 15px !important;
  color: black;
}
</style>
